var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarGolden = function SvgCalendarGolden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M14.811 38.929c-.195-.194-.303-.47-.304-.791V35.02c.002-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.179-.858l3.336-1.132c.442-.149.866-.128 1.178.058q.104.062.186.144l5.057 5.148a1 1 0 0 0-.186-.144c-.312-.186-.736-.206-1.178-.058l-3.337 1.133c-.442.15-.865.46-1.178.857-.312.398-.488.854-.49 1.267v3.117c.001.322.109.597.304.79z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M26.489 34.966c-.196-.194-.303-.47-.304-.79v-3.118c.001-.413.177-.869.49-1.267a2.6 2.6 0 0 1 1.178-.857L31.19 27.8c.442-.148.865-.128 1.178.058q.103.062.186.144l5.057 5.148a1 1 0 0 0-.186-.144c-.313-.185-.736-.206-1.178-.057l-3.337 1.132c-.442.151-.866.46-1.178.858-.313.398-.489.853-.49 1.266v3.117c0 .322.108.597.304.79z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M38.167 31.003c-.195-.194-.303-.47-.304-.791v-3.117c.002-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.178-.857l3.337-1.133c.442-.149.866-.128 1.178.058q.104.062.186.144l5.057 5.148a1 1 0 0 0-.186-.144c-.312-.186-.736-.206-1.178-.058l-3.337 1.133c-.442.151-.865.46-1.178.857-.312.399-.489.854-.49 1.267v3.117c.001.322.108.597.304.79z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M20.878 10.146c.196.194.302.47.302.792v3.117c0 .414-.175.87-.488 1.268a2.6 2.6 0 0 1-1.18.857c-.442.15-.867.13-1.18-.056a1 1 0 0 1-.186-.144l5.057 5.148a1 1 0 0 0 .187.144c.312.186.737.206 1.18.056s.866-.458 1.179-.857.488-.854.488-1.268v-3.116c0-.323-.106-.599-.302-.793z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M40.897 3.352c.196.194.303.47.303.793V7.26c0 .414-.176.87-.489 1.268a2.6 2.6 0 0 1-1.18.857c-.442.15-.867.13-1.18-.056a1 1 0 0 1-.185-.144l5.056 5.148a1 1 0 0 0 .187.144c.312.186.737.206 1.18.056s.866-.458 1.179-.857.489-.854.489-1.267V9.293c0-.323-.107-.598-.303-.792z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M6.166 26.943V20.6c.017-1.23.554-2.582 1.492-3.756s2.201-2.077 3.513-2.509l3.336-1.132 5.057 5.148-3.336 1.133c-1.312.432-2.575 1.334-3.513 2.508-.939 1.175-1.475 2.525-1.492 3.756v6.343z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M14.507 13.203v3.117c0 .942.305 1.752.863 2.332l5.057 5.148c-.558-.58-.863-1.39-.863-2.332v-3.117z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M15.37 18.652q.265.274.603.476c.939.559 2.212.62 3.54.169 1.326-.45 2.6-1.375 3.538-2.57.939-1.196 1.466-2.564 1.466-3.804V9.806l10.01-3.397 5.056 5.149-10.01 3.396v3.117c0 1.24-.526 2.608-1.465 3.804s-2.212 2.12-3.539 2.57-2.6.39-3.539-.168a2.9 2.9 0 0 1-.603-.477z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M34.526 6.41v3.116c0 .943.305 1.752.863 2.332l5.057 5.148c-.558-.58-.863-1.39-.863-2.331v-3.117z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M35.39 11.858q.264.275.602.477c.939.558 2.212.619 3.54.168s2.6-1.375 3.538-2.57c.939-1.195 1.466-2.563 1.466-3.803V3.013l3.336-1.133c1.312-.458 2.575-.413 3.513.125q.34.195.605.461l5.057 5.149a2.9 2.9 0 0 0-.605-.462c-.938-.538-2.201-.582-3.513-.124L49.593 8.16v3.117c0 1.24-.528 2.608-1.466 3.803-.939 1.196-2.212 2.12-3.539 2.57-1.327.451-2.6.39-3.539-.168a2.9 2.9 0 0 1-.603-.477z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M51.99 2.466c.561.563.874 1.356.887 2.282v6.343L6.166 26.943l5.057 5.148L57.934 16.24V9.897c-.013-.927-.326-1.72-.887-2.282z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M7.01 57.34q.281.296.648.507c.938.538 2.202.582 3.513.124l36.702-12.454c1.311-.433 2.575-1.335 3.513-2.51s1.474-2.524 1.491-3.755V14.208l5.057 5.148V44.4c-.017 1.23-.553 2.582-1.491 3.756-.939 1.175-2.202 2.077-3.514 2.509L16.228 63.12c-1.312.458-2.575.413-3.513-.125q-.366-.211-.648-.506z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M14.811 49.838c-.195-.194-.303-.47-.304-.791V45.93c.002-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.179-.857l3.336-1.133c.442-.148.866-.128 1.178.058q.104.062.186.144l5.057 5.148a1 1 0 0 0-.186-.144c-.312-.185-.736-.206-1.178-.057l-3.337 1.132c-.442.151-.865.46-1.178.857-.312.399-.488.854-.49 1.267v3.117c.001.322.109.597.304.791z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M26.489 45.875c-.196-.194-.303-.47-.304-.791v-3.117c.001-.413.177-.869.49-1.267a2.6 2.6 0 0 1 1.178-.857l3.337-1.133c.442-.149.865-.128 1.178.058q.103.062.186.144l5.057 5.148a1 1 0 0 0-.186-.144c-.313-.185-.736-.206-1.178-.057L32.91 44.99c-.442.151-.866.46-1.178.857-.313.398-.489.854-.49 1.267v3.117c0 .322.108.597.304.79z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_linear_7551_12021)",
    fillRule: "evenodd",
    d: "M44.232 24.04c.196.194.303.469.304.79v3.118c-.001.413-.177.868-.49 1.266a2.6 2.6 0 0 1-1.178.858l-3.337 1.132c-.442.15-.865.128-1.178-.058a1 1 0 0 1-.186-.143l5.057 5.148a1 1 0 0 0 .186.144c.313.185.736.206 1.178.058l3.337-1.133c.442-.15.865-.46 1.178-.857.313-.398.489-.854.49-1.267v-3.117c-.001-.322-.109-.597-.304-.79z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_7551_12021)",
    d: "M52.877 4.748v6.343L6.166 26.943V20.6c.017-1.23.554-2.582 1.492-3.756s2.201-2.077 3.513-2.509l3.336-1.132v3.117c0 1.24.528 2.25 1.466 2.808.939.559 2.212.62 3.54.169 1.326-.45 2.6-1.375 3.538-2.57.939-1.196 1.466-2.564 1.466-3.804V9.806l10.01-3.397v3.117c0 1.24.527 2.25 1.465 2.809.939.558 2.212.619 3.54.168s2.6-1.375 3.538-2.57c.939-1.195 1.466-2.564 1.466-3.803V3.013l3.336-1.133c1.312-.458 2.575-.413 3.513.125.939.537 1.475 1.524 1.492 2.743M6.166 30.06v25.044c.017 1.219.554 2.206 1.492 2.743.938.538 2.201.582 3.513.124l36.701-12.455c1.312-.432 2.575-1.334 3.513-2.508.939-1.175 1.475-2.525 1.492-3.756V14.208zM21.18 46.782c-.001.414-.177.87-.49 1.267a2.6 2.6 0 0 1-1.178.858l-3.336 1.132c-.442.15-.866.128-1.179-.058-.312-.186-.488-.522-.49-.934V45.93c.002-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.179-.857l3.336-1.133c.442-.149.866-.128 1.178.058.313.186.489.522.49.934zm0-10.909c-.001.414-.177.87-.49 1.267a2.6 2.6 0 0 1-1.178.858l-3.336 1.132c-.442.149-.866.128-1.179-.058-.312-.186-.488-.522-.49-.934V35.02c.002-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.179-.858l3.336-1.132c.442-.149.866-.128 1.178.058.313.186.489.522.49.935zm11.678 6.947c-.001.413-.177.868-.49 1.266a2.6 2.6 0 0 1-1.178.858l-3.337 1.132c-.442.15-.865.128-1.178-.058-.312-.185-.489-.521-.49-.934v-3.117c.001-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.178-.857l3.337-1.133c.442-.149.866-.128 1.178.058.313.186.489.522.49.935zm0-10.91c-.001.414-.177.87-.49 1.267a2.6 2.6 0 0 1-1.178.858l-3.337 1.132c-.442.15-.865.128-1.178-.058s-.489-.522-.49-.934v-3.117c.001-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.178-.858l3.337-1.132c.442-.149.866-.128 1.178.058.313.186.489.522.49.934zm11.678-3.963c-.001.414-.178.87-.49 1.267a2.6 2.6 0 0 1-1.178.858l-3.337 1.132c-.442.15-.865.128-1.178-.058s-.489-.521-.49-.934v-3.117c.001-.413.177-.869.49-1.267a2.6 2.6 0 0 1 1.178-.857l3.337-1.133c.442-.149.865-.128 1.178.058s.489.522.49.934zM21.18 10.938v3.117c0 .414-.175.87-.488 1.268a2.6 2.6 0 0 1-1.18.857c-.442.15-.867.13-1.18-.056s-.488-.523-.488-.936V12.07c0-.414.176-.87.488-1.268a2.6 2.6 0 0 1 1.18-.857c.442-.15.867-.13 1.18.056s.488.523.488.936M41.2 4.145v3.117c0 .413-.176.869-.49 1.267a2.6 2.6 0 0 1-1.179.857c-.442.15-.867.13-1.18-.056s-.488-.523-.488-.936V5.277c0-.413.176-.87.489-1.268a2.6 2.6 0 0 1 1.18-.857c.442-.15.866-.13 1.179.056.313.187.489.523.489.937"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_linear_7551_12021)",
    d: "M52.877 4.748v6.343L6.166 26.943V20.6c.017-1.23.554-2.582 1.492-3.756s2.201-2.077 3.513-2.509l3.336-1.132v3.117c0 1.24.528 2.25 1.466 2.808.939.559 2.212.62 3.54.169 1.326-.45 2.6-1.375 3.538-2.57.939-1.196 1.466-2.564 1.466-3.804V9.806l10.01-3.397v3.117c0 1.24.527 2.25 1.465 2.809.939.558 2.212.619 3.54.168s2.6-1.375 3.538-2.57c.939-1.195 1.466-2.564 1.466-3.803V3.013l3.336-1.133c1.312-.458 2.575-.413 3.513.125.939.537 1.475 1.524 1.492 2.743M6.166 30.06v25.044c.017 1.219.554 2.206 1.492 2.743.938.538 2.201.582 3.513.124l36.701-12.455c1.312-.432 2.575-1.334 3.513-2.508.939-1.175 1.475-2.525 1.492-3.756V14.208zM21.18 46.782c-.001.414-.177.87-.49 1.267a2.6 2.6 0 0 1-1.178.858l-3.336 1.132c-.442.15-.866.128-1.179-.058-.312-.186-.488-.522-.49-.934V45.93c.002-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.179-.857l3.336-1.133c.442-.149.866-.128 1.178.058.313.186.489.522.49.934zm0-10.909c-.001.414-.177.87-.49 1.267a2.6 2.6 0 0 1-1.178.858l-3.336 1.132c-.442.149-.866.128-1.179-.058-.312-.186-.488-.522-.49-.934V35.02c.002-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.179-.858l3.336-1.132c.442-.149.866-.128 1.178.058.313.186.489.522.49.935zm11.678 6.947c-.001.413-.177.868-.49 1.266a2.6 2.6 0 0 1-1.178.858l-3.337 1.132c-.442.15-.865.128-1.178-.058-.312-.185-.489-.521-.49-.934v-3.117c.001-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.178-.857l3.337-1.133c.442-.149.866-.128 1.178.058.313.186.489.522.49.935zm0-10.91c-.001.414-.177.87-.49 1.267a2.6 2.6 0 0 1-1.178.858l-3.337 1.132c-.442.15-.865.128-1.178-.058s-.489-.522-.49-.934v-3.117c.001-.413.178-.869.49-1.267a2.6 2.6 0 0 1 1.178-.858l3.337-1.132c.442-.149.866-.128 1.178.058.313.186.489.522.49.934zm11.678-3.963c-.001.414-.178.87-.49 1.267a2.6 2.6 0 0 1-1.178.858l-3.337 1.132c-.442.15-.865.128-1.178-.058s-.489-.521-.49-.934v-3.117c.001-.413.177-.869.49-1.267a2.6 2.6 0 0 1 1.178-.857l3.337-1.133c.442-.149.865-.128 1.178.058s.489.522.49.934zM21.18 10.938v3.117c0 .414-.175.87-.488 1.268a2.6 2.6 0 0 1-1.18.857c-.442.15-.867.13-1.18-.056s-.488-.523-.488-.936V12.07c0-.414.176-.87.488-1.268a2.6 2.6 0 0 1 1.18-.857c.442-.15.867-.13 1.18.056s.488.523.488.936M41.2 4.145v3.117c0 .413-.176.869-.49 1.267a2.6 2.6 0 0 1-1.179.857c-.442.15-.867.13-1.18-.056s-.488-.523-.488-.936V5.277c0-.413.176-.87.489-1.268a2.6 2.6 0 0 1 1.18-.857c.442-.15.866-.13 1.179.056.313.187.489.523.489.937"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7551_12021",
    x1: 14.407,
    x2: 14.407,
    y1: 31.314,
    y2: 43.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7551_12021",
    x1: 26.085,
    x2: 26.085,
    y1: 27.351,
    y2: 39.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7551_12021",
    x1: 37.763,
    x2: 37.763,
    y1: 23.388,
    y2: 36.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7551_12021",
    x1: 18.075,
    x2: 18.075,
    y1: 9.826,
    y2: 21.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7551_12021",
    x1: 38.094,
    x2: 38.094,
    y1: 3.033,
    y2: 14.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7551_12021",
    x1: 1.791,
    x2: 41.19,
    y1: 10.791,
    y2: 13.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#DEF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#ADD8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#CAE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B427A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7551_12021",
    x1: 14.455,
    x2: 14.455,
    y1: 12.903,
    y2: 23.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7551_12021",
    x1: 7.464,
    x2: 77.866,
    y1: 4.068,
    y2: 12.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#DEF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#ADD8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#CAE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B427A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7551_12021",
    x1: 34.474,
    x2: 34.474,
    y1: 6.109,
    y2: 16.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7551_12021",
    x1: 28.317,
    x2: 91.287,
    y1: -0.525,
    y2: 7.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#DEF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#ADD8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#CAE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B427A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7551_12021",
    x1: 5.711,
    x2: 5.711,
    y1: 1.627,
    y2: 31.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7551_12021",
    x1: 6.562,
    x2: 6.562,
    y1: 12.813,
    y2: 62.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7551_12021",
    x1: 14.407,
    x2: 14.407,
    y1: 42.223,
    y2: 54.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7551_12021",
    x1: 26.085,
    x2: 26.085,
    y1: 38.26,
    y2: 50.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#723C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311209"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7551_12021",
    x1: 34.436,
    x2: 67.93,
    y1: 22.455,
    y2: 25.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CC3F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#DEF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    stopColor: "#ADD8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#CAE5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B427A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7551_12021",
    x1: -3.439,
    x2: 28.377,
    y1: 70.428,
    y2: 19.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4796F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47D3F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7551_12021",
    x1: 50.479,
    x2: -0.343,
    y1: 56.893,
    y2: 11.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A23A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#FFE57C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD546"
  })))));
};
export default SvgCalendarGolden;